<div class="lp-root">

  <!-- ══════════════════════════════════════════════════
       ANNOUNCEMENT BAR
  ══════════════════════════════════════════════════ -->
  <div class="announce-bar">
    <div class="announce-bar__inner">
      <div class="announce-bar__contacts">
        <a href="tel:+255696683636" class="announce-bar__link">
          <span class="announce-bar__icon-wrap"><mat-icon>phone</mat-icon></span>
          +255 696 683 636
        </a>
        <a href="mailto:us@support.akiliunde.com" class="announce-bar__link">
          <span class="announce-bar__icon-wrap"><mat-icon>email</mat-icon></span>
          us&#64;support.akiliunde.com
        </a>
      </div>
      <div class="announce-bar__social">
        <span class="announce-bar__follow">{{ 'landing.announce.follow_us' | translate }}</span>
        <a href="https://www.facebook.com/profile.php?id=61593706234719" target="_blank"
          class="announce-bar__social-btn" aria-label="Facebook">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
        <a href="https://www.instagram.com/rizzansgroup/" target="_blank" class="announce-bar__social-btn"
          aria-label="Instagram">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
          </svg>
        </a>
        <a href="#" class="announce-bar__social-btn" aria-label="X/Twitter">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.262 5.633L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════
       STICKY NAVBAR
  ══════════════════════════════════════════════════ -->
  <nav class="navbar" id="navbar">
    <div class="navbar__inner">
      <!-- Brand -->
      <div class="navbar__brand">
        <div class="navbar__logo">
          <div class="navbar__logo-glow"></div>
          <mat-icon class="navbar__logo-icon">point_of_sale</mat-icon>
        </div>
        <div class="navbar__brand-text">
          <span class="navbar__name">Nova Point</span>
          <span class="navbar__tagline">{{ 'landing.nav.tagline' | translate }}</span>
        </div>
      </div>

      <!-- Links -->
      <div class="navbar__links">
        <a class="navbar__link" (click)="scrollToSection('features')">{{ 'landing.nav.features' | translate }}</a>
        <a class="navbar__link" (click)="scrollToSection('products')">{{ 'landing.nav.products' | translate }}</a>
        <a class="navbar__link" (click)="scrollToSection('pricing')">{{ 'landing.nav.pricing' | translate }}</a>
        <a class="navbar__link" (click)="scrollToSection('contact')">{{ 'landing.nav.contact' | translate }}</a>
      </div>

      <!-- Actions -->
      <div class="navbar__actions">
        <!-- Theme toggle -->
        <button class="navbar__icon-btn" (click)="toggleTheme()" [matTooltip]="(isDarkTheme ? 'landing.nav.light_mode' : 'landing.nav.dark_mode') | translate">
          <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
        <!-- Language switcher -->
        <button class="navbar__icon-btn navbar__lang-btn" (click)="toggleLanguage()" [matTooltip]="'landing.nav.switch_language' | translate">
          {{ currentLang.toUpperCase() }}
        </button>
        <!-- Cart -->
        <button class="navbar__cart-btn" (click)="openCart()" [attr.aria-label]="('landing.nav.cart_aria' | translate: { count: cartItemsCount })">
          <mat-icon [matBadge]="cartItemsCount" [matBadgeHidden]="cartItemsCount === 0" matBadgeColor="warn"
            matBadgeSize="small">shopping_cart</mat-icon>
        </button>
        <!-- Customer login temporarily hidden — customer-facing shopping isn't live yet. -->
        <button class="navbar__btn navbar__btn--primary" (click)="toggleSellerLogin()">
          <mat-icon>store</mat-icon>
          {{ 'landing.nav.seller_portal' | translate }}
        </button>
      </div>
    </div>
  </nav>

  <!-- ══════════════════════════════════════════════════
       HERO SECTION
  ══════════════════════════════════════════════════ -->
  <section class="hero" id="hero">
    <!-- Animated background -->
    <div class="hero__bg">
      <div class="hero__blob hero__blob--1"></div>
      <div class="hero__blob hero__blob--2"></div>
      <div class="hero__blob hero__blob--3"></div>
      <div class="hero__grid"></div>
    </div>

    <div class="hero__inner">
      <!-- LEFT COLUMN: content / forms -->
      <div class="hero__content">

        @if (!showLoginForm && !showSignupForm && !showSellerLogin) {
        <div class="hero__pitch">
          <div class="hero__badge">
            <span class="hero__badge-dot"></span>
            {{ 'landing.hero.badge' | translate }}
          </div>

          <h1 class="hero__title">
            {{ 'landing.hero.title_line1' | translate }}
            <span class="hero__title-accent">{{ 'landing.hero.title_accent' | translate }}</span>
          </h1>

          <p class="hero__desc">
            {{ 'landing.hero.desc' | translate }}
          </p>

          <!-- Feature pills -->
          <div class="hero__features">
            <div class="hero__feature">
              <div class="hero__feature-icon hero__feature-icon--green"><mat-icon>shopping_cart</mat-icon></div>
              <span>{{ 'landing.hero.feature_ordering' | translate }}</span>
            </div>
            <div class="hero__feature">
              <div class="hero__feature-icon hero__feature-icon--blue"><mat-icon>inventory</mat-icon></div>
              <span>{{ 'landing.hero.feature_inventory' | translate }}</span>
            </div>
            <div class="hero__feature">
              <div class="hero__feature-icon hero__feature-icon--purple"><mat-icon>analytics</mat-icon></div>
              <span>{{ 'landing.hero.feature_analytics' | translate }}</span>
            </div>
            <div class="hero__feature">
              <div class="hero__feature-icon hero__feature-icon--orange"><mat-icon>speed</mat-icon></div>
              <span>{{ 'landing.hero.feature_checkout' | translate }}</span>
            </div>
          </div>

          <!-- CTAs -->
          <!-- Customer login temporarily hidden — customer-facing shopping isn't live yet. -->
          <div class="hero__ctas">
            <button class="cta-btn cta-btn--dark" (click)="toggleSellerLogin()">
              <mat-icon>store</mat-icon>
              {{ 'landing.nav.seller_portal' | translate }}
            </button>
          </div>

          <!-- Mobile app download badges -->
          <div class="hero__stores">
            <a class="store-btn"
               [href]="playStoreUrl"
               target="_blank"
               rel="noopener noreferrer"
               [attr.aria-label]="'landing.stores.play_store_aria' | translate">
              <svg class="store-btn__logo" viewBox="0 0 512 512" aria-hidden="true">
                <path fill="#00d2ff" d="M48 59.49v393a4.33 4.33 0 007.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0048 59.49z"/>
                <path fill="#00f076" d="M345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62.3-9.34 1.03L260 212.09z"/>
                <path fill="#ff3a44" d="M89.22 479.36L345.8 338 260 300.06 79.72 478.33c.71.73 4.9 3.43 9.5 1.03z"/>
                <path fill="#ffd400" d="M449.38 231l-71.65-39.46L297.94 256l79.79 64.43 71.65-39.46c14.46-7.9 14.46-26.05 0-33.97z"/>
              </svg>
              <span class="store-btn__text">
                <small>{{ 'landing.stores.get_it_on' | translate }}</small>
                <strong>Google Play</strong>
              </span>
            </a>

            <button type="button"
                    class="store-btn"
                    (click)="openAppStoreComingSoon(appStoreComingSoon)"
                    [attr.aria-label]="'landing.stores.app_store_aria' | translate">
              <svg class="store-btn__logo" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#fff" d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
              </svg>
              <span class="store-btn__text">
                <small>{{ 'landing.stores.download_on_the' | translate }}</small>
                <strong>App Store</strong>
              </span>
            </button>
          </div>

          <!-- App Store "coming soon" dialog -->
          <ng-template #appStoreComingSoon>
            <div class="coming-soon-dialog">
              <div class="coming-soon-dialog__icon"><mat-icon>rocket_launch</mat-icon></div>
              <h2 mat-dialog-title>{{ 'landing.stores.coming_soon_title' | translate }}</h2>
              <mat-dialog-content>
                <p>{{ 'landing.stores.coming_soon_message' | translate }}</p>
              </mat-dialog-content>
              <mat-dialog-actions align="center">
                <button mat-flat-button color="primary" mat-dialog-close>
                  {{ 'landing.stores.got_it' | translate }}
                </button>
              </mat-dialog-actions>
            </div>
          </ng-template>
          <!-- <div class="hero__signup-hint">
              <button class="cta-btn cta-btn--outline" (click)="toggleSignupForm()">
                <mat-icon>person_add</mat-icon>
                New Customer? Sign Up Free
              </button>
            </div> -->
        </div>
        }

        <!-- ── Customer Login Form ── -->
        @if (showLoginForm) {
        <div class="auth-card">
          <div class="auth-card__glow"></div>
          <button mat-icon-button class="auth-card__close"
            (click)="toggleLoginForm()"><mat-icon>close</mat-icon></button>
          <div class="auth-card__inner">
            <div class="auth-card__head">
              <div class="auth-card__head-icon auth-card__head-icon--orange"><mat-icon>shopping_bag</mat-icon></div>
              <div>
                <h2>{{ 'landing.auth.customer_login_title' | translate }}</h2>
                <p>{{ 'landing.auth.customer_login_subtitle' | translate }}</p>
              </div>
            </div>
            <form (ngSubmit)="login()" [formGroup]="form" class="auth-card__body">
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.email_or_phone' | translate }}</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input type="text" formControlName="username" matInput autocomplete="username">
                <mat-error *ngIf="!form.get('username').valid && form.get('username').touched">{{ 'landing.auth.email_or_phone_required' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.password' | translate }}</mat-label>
                <mat-icon matPrefix>lock</mat-icon>
                <input type="password" formControlName="password" matInput autocomplete="current-password">
                <mat-error *ngIf="!form.get('password').valid && form.get('password').touched">{{ 'landing.auth.password_required' | translate }}</mat-error>
              </mat-form-field>
              <div class="auth-card__row">
                <mat-checkbox class="auth-card__check">{{ 'landing.auth.remember_me' | translate }}</mat-checkbox>
                <a routerLink="/forgot-password" class="auth-card__forgot">{{ 'landing.auth.forgot_password' | translate }}</a>
              </div>
              <button [disabled]="!form.valid" type="submit" class="auth-submit-btn">
                <mat-icon>login</mat-icon> {{ 'landing.auth.login_to_shop' | translate }}
              </button>
              <p class="auth-card__switch">
                {{ 'landing.auth.no_account' | translate }}
                <a (click)="toggleSignupForm()" class="auth-card__switch-link">{{ 'landing.auth.sign_up_here' | translate }}</a>
              </p>
              <p class="auth-card__switch auth-card__switch--muted">
                {{ 'landing.auth.cant_login' | translate }}
                <a [href]="deleteAccountUrl" target="_blank" rel="noopener" class="auth-card__switch-link">{{ 'landing.auth.delete_account_here' | translate }}</a>
              </p>
            </form>
          </div>
        </div>
        }

        <!-- ── Seller Login Form ── -->
        @if (showSellerLogin) {
        <div class="auth-card">
          <div class="auth-card__glow auth-card__glow--dark"></div>
          <button mat-icon-button class="auth-card__close"
            (click)="toggleSellerLogin()"><mat-icon>close</mat-icon></button>
          <div class="auth-card__inner">
            <div class="auth-card__head">
              <div class="auth-card__head-icon auth-card__head-icon--dark"><mat-icon>store</mat-icon></div>
              <div>
                <h2>{{ 'landing.auth.seller_portal_title' | translate }}</h2>
                <p>{{ 'landing.auth.seller_portal_subtitle' | translate }}</p>
              </div>
            </div>
            <form (ngSubmit)="sellerLogin()" [formGroup]="sellerForm" class="auth-card__body">
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.business_email_label' | translate }}</mat-label>
                <mat-icon matPrefix>business</mat-icon>
                <input type="text" formControlName="email" matInput autocomplete="email">
                <mat-error *ngIf="!sellerForm.get('email').valid && sellerForm.get('email').touched">{{ 'landing.auth.business_email_required' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.password' | translate }}</mat-label>
                <mat-icon matPrefix>lock</mat-icon>
                <input type="password" formControlName="password" matInput autocomplete="current-password">
                <mat-error *ngIf="!sellerForm.get('password').valid && sellerForm.get('password').touched">{{ 'landing.auth.password_required' | translate }}</mat-error>
              </mat-form-field>
              <div class="auth-card__row">
                <mat-checkbox class="auth-card__check" formControlName="rememberMe">{{ 'landing.auth.keep_signed_in' | translate }}</mat-checkbox>
                <a routerLink="/forgot-password" class="auth-card__forgot">{{ 'landing.auth.forgot_password' | translate }}</a>
              </div>
              <button [disabled]="!sellerForm.valid" type="submit" class="auth-submit-btn auth-submit-btn--dark">
                <mat-icon>dashboard</mat-icon> {{ 'landing.auth.access_dashboard' | translate }}
              </button>
              <p class="auth-card__switch">
                {{ 'landing.auth.new_seller' | translate }}
                <a routerLink="/registration" class="auth-card__switch-link">{{ 'landing.auth.register_business' | translate }}</a>
              </p>
              <p class="auth-card__switch auth-card__switch--muted">
                {{ 'landing.auth.cant_login' | translate }}
                <a [href]="deleteAccountUrl" target="_blank" rel="noopener" class="auth-card__switch-link">{{ 'landing.auth.delete_account_here' | translate }}</a>
              </p>
            </form>
          </div>
        </div>
        }

        <!-- ── Signup Form ── -->
        @if (showSignupForm) {
        <div class="auth-card auth-card--scroll">
          <div class="auth-card__header auth-card__header--orange auth-card__header--sticky">
            <div class="auth-card__header-icon"><mat-icon>person_add</mat-icon></div>
            <h2>{{ 'landing.auth.create_account_title' | translate }}</h2>
            <button mat-icon-button class="auth-card__close"
              (click)="toggleSignupForm()"><mat-icon>close</mat-icon></button>
          </div>
          <form (ngSubmit)="submitSignup(signupForm.value)" [formGroup]="signupForm" class="auth-card__body">
            <div class="auth-grid-2">
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.first_name' | translate }}</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input type="text" formControlName="firstName" matInput>
                <mat-error
                  *ngIf="!signupForm.get('firstName').valid && signupForm.get('firstName').touched">{{ 'landing.auth.required' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="auth-field">
                <mat-label>{{ 'landing.auth.last_name' | translate }}</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input type="text" formControlName="lastName" matInput>
                <mat-error
                  *ngIf="!signupForm.get('lastName').valid && signupForm.get('lastName').touched">{{ 'landing.auth.required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="auth-field">
              <mat-label>{{ 'landing.auth.email_address' | translate }}</mat-label>
              <mat-icon matPrefix>email</mat-icon>
              <input type="email" formControlName="email" matInput>
              <mat-error *ngIf="!signupForm.get('email').valid && signupForm.get('email').touched">{{ 'landing.auth.valid_email_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="auth-field">
              <mat-label>{{ 'landing.auth.phone_number' | translate }}</mat-label>
              <mat-icon matPrefix>phone</mat-icon>
              <input type="tel" formControlName="phoneNumber" matInput>
              <mat-error *ngIf="!signupForm.get('phoneNumber').valid && signupForm.get('phoneNumber').touched">{{ 'landing.auth.valid_phone_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="auth-field">
              <mat-label>{{ 'landing.auth.password' | translate }}</mat-label>
              <mat-icon matPrefix>lock</mat-icon>
              <input type="password" formControlName="password" matInput>
              <mat-hint>{{ 'landing.auth.at_least_8_chars' | translate }}</mat-hint>
              <mat-error *ngIf="!signupForm.get('password').valid && signupForm.get('password').touched">{{ 'landing.auth.min_8_chars' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="auth-field">
              <mat-label>{{ 'landing.auth.confirm_password' | translate }}</mat-label>
              <mat-icon matPrefix>lock</mat-icon>
              <input type="password" formControlName="confirmPassword" matInput>
              <mat-error
                *ngIf="!signupForm.get('confirmPassword').valid && signupForm.get('confirmPassword').touched">{{ 'landing.auth.passwords_must_match' | translate }}</mat-error>
            </mat-form-field>
            <mat-checkbox class="auth-card__check">
              {{ 'landing.auth.agree_prefix' | translate }}
              <a routerLink="/terms-of-service" target="_blank" (click)="$event.stopPropagation()"
                class="auth-card__switch-link">{{ 'landing.auth.terms' | translate }}</a>
              {{ 'landing.auth.and' | translate }}
              <a routerLink="/privacy-policy" target="_blank" (click)="$event.stopPropagation()"
                class="auth-card__switch-link">{{ 'landing.auth.privacy_policy' | translate }}</a>
            </mat-checkbox>
            <button [disabled]="!signupForm.valid" type="submit" class="auth-submit-btn">
              <mat-icon>person_add</mat-icon> {{ 'landing.auth.create_my_account' | translate }}
            </button>
            <p class="auth-card__switch">
              {{ 'landing.auth.already_have_account' | translate }}
              <a (click)="toggleLoginForm()" class="auth-card__switch-link">{{ 'landing.auth.login_here' | translate }}</a>
            </p>
          </form>
        </div>
        }
      </div>

      <!-- RIGHT COLUMN: visual showcase -->
      <div class="hero__visual">
        <!-- Main card -->
        <div class="showcase-card">
          <div class="showcase-card__glow"></div>
          <div class="showcase-card__inner">
            <mat-icon class="showcase-card__icon">point_of_sale</mat-icon>
            <p class="showcase-card__label">Nova Point</p>
            <p class="showcase-card__sub">{{ 'landing.showcase.sub' | translate }}</p>
          </div>
        </div>

        <!-- Floating stat: Orders -->
        <div class="stat-float stat-float--bl">
          <div class="stat-float__icon stat-float__icon--green"><mat-icon>shopping_cart</mat-icon></div>
          <div>
            <p class="stat-float__num">5,000+</p>
            <p class="stat-float__label">{{ 'landing.showcase.stat_daily_orders' | translate }}</p>
          </div>
        </div>

        <!-- Floating stat: Sellers -->
        <div class="stat-float stat-float--tr">
          <div class="stat-float__icon stat-float__icon--blue"><mat-icon>storefront</mat-icon></div>
          <div>
            <p class="stat-float__num">200+</p>
            <p class="stat-float__label">{{ 'landing.showcase.stat_active_sellers' | translate }}</p>
          </div>
        </div>

        <!-- Floating stat: Revenue -->
        <div class="stat-float stat-float--br">
          <div class="stat-float__icon stat-float__icon--orange"><mat-icon>trending_up</mat-icon></div>
          <div>
            <p class="stat-float__num">98%</p>
            <p class="stat-float__label">{{ 'landing.showcase.stat_uptime' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════
       FEATURES STRIP
  ══════════════════════════════════════════════════ -->
  <section class="features-strip" id="features">
    <div class="features-strip__inner">
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#667eea,#764ba2)">
          <mat-icon>point_of_sale</mat-icon></div>
        <h3>{{ 'landing.features.smart_pos_title' | translate }}</h3>
        <p>{{ 'landing.features.smart_pos_desc' | translate }}</p>
      </div>
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#f093fb,#f5576c)">
          <mat-icon>inventory_2</mat-icon></div>
        <h3>{{ 'landing.features.inventory_title' | translate }}</h3>
        <p>{{ 'landing.features.inventory_desc' | translate }}</p>
      </div>
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#4facfe,#00f2fe)">
          <mat-icon>analytics</mat-icon></div>
        <h3>{{ 'landing.features.analytics_title' | translate }}</h3>
        <p>{{ 'landing.features.analytics_desc' | translate }}</p>
      </div>
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#43e97b,#38f9d7)">
          <mat-icon>people</mat-icon></div>
        <h3>{{ 'landing.features.crm_title' | translate }}</h3>
        <p>{{ 'landing.features.crm_desc' | translate }}</p>
      </div>
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#fa709a,#fee140)">
          <mat-icon>receipt_long</mat-icon></div>
        <h3>{{ 'landing.features.invoicing_title' | translate }}</h3>
        <p>{{ 'landing.features.invoicing_desc' | translate }}</p>
      </div>
      <div class="feature-tile">
        <div class="feature-tile__icon" style="background: linear-gradient(135deg,#FF6B35,#FF8C42)">
          <mat-icon>cloud_sync</mat-icon></div>
        <h3>{{ 'landing.features.cloud_sync_title' | translate }}</h3>
        <p>{{ 'landing.features.cloud_sync_desc' | translate }}</p>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════
       PRICING SECTION
  ══════════════════════════════════════════════════ -->
  <section class="pricing-section" id="pricing">
    <div class="pricing-section__inner">
      <div class="section-header">
        <div class="section-header__badge">
          <mat-icon>payments</mat-icon>
          {{ 'landing.pricing.badge' | translate }}
        </div>
        <h2 class="section-header__title">{{ 'landing.pricing.title' | translate }}</h2>
        <p class="section-header__desc">{{ 'landing.pricing.desc' | translate }}</p>
      </div>

      @if (plansLoading) {
      <p class="pricing-status">{{ 'landing.pricing.loading' | translate }}</p>
      } @else if (plans.length) {
      <div class="pricing-grid">
        @for (plan of plans; track plan.uuid) {
        <div class="pricing-card">
          <h3 class="pricing-card__name">{{ plan.name }}</h3>
          @if (plan.description) {
          <p class="pricing-card__desc">{{ plan.description }}</p>
          }
          <div class="pricing-card__price">
            <span class="pricing-card__amount">TZS {{ plan.price | number:'1.0-0' }}</span>
            <span class="pricing-card__period">{{ 'landing.pricing.per_days' | translate: { days: plan.durationDays } }}</span>
          </div>
          <ul class="pricing-card__features">
            <li>
              <mat-icon>check_circle</mat-icon>
              {{ plan.maxUsers === -1 ? ('landing.pricing.unlimited' | translate) : plan.maxUsers }} {{ 'landing.pricing.staff_accounts' | translate }}
            </li>
            <li>
              <mat-icon>check_circle</mat-icon>
              {{ plan.maxProducts === -1 ? ('landing.pricing.unlimited' | translate) : plan.maxProducts }} {{ 'landing.pricing.products' | translate }}
            </li>
          </ul>
          <button class="cta-btn cta-btn--primary pricing-card__cta" routerLink="/registration">
            {{ 'landing.pricing.get_started' | translate }}
          </button>
        </div>
        }
      </div>
      } @else {
      <p class="pricing-status">{{ 'landing.pricing.unavailable' | translate }}</p>
      }
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════
       PRODUCTS SECTION
  ══════════════════════════════════════════════════ -->
  <section class="products-section" id="products">
    <div class="products-section__inner">

      <!-- Header -->
      <div class="section-header">
        <div class="section-header__badge">
          <mat-icon>shopping_bag</mat-icon>
          {{ 'landing.products.badge' | translate }}
        </div>
        <h2 class="section-header__title">{{ 'landing.products.title' | translate }}</h2>
        <p class="section-header__desc">{{ 'landing.products.desc' | translate }}</p>
      </div>

      <!-- Category Tabs -->
      <div class="category-tabs">
        <div *ngFor="let category of productCategories" (click)="selectCategory(category.id)" class="category-tab"
          [class.category-tab--active]="selectedCategory === category.id">
          <mat-icon>{{ category.icon }}</mat-icon>
          {{ category.nameKey | translate }}
        </div>
      </div>

      <!-- Products Grid -->
      <div class="products-grid">
        @for (product of getFilteredProducts(); track product.id) {
        <div class="product-card">
          <!-- Badges -->
          @if (product.discount) {
          <div class="product-card__badge product-card__badge--sale">-{{ product.discount }}% OFF</div>
          }
          @if (product.isNew) {
          <div class="product-card__badge product-card__badge--new">{{ 'landing.products.new_badge' | translate }}</div>
          }

          <!-- Image area -->
          <div class="product-card__image">
            <mat-icon class="product-card__placeholder-icon">{{ product.icon }}</mat-icon>
            <!-- Hover overlay -->
            <div class="product-card__overlay">
              <button (click)="viewProductDetails(product)" mat-mini-fab
                class="product-card__action-btn product-card__action-btn--view">
                <mat-icon>visibility</mat-icon>
              </button>
              <button (click)="addToCart(product)" mat-mini-fab
                class="product-card__action-btn product-card__action-btn--cart">
                <mat-icon>shopping_cart</mat-icon>
              </button>
            </div>
          </div>

          <!-- Info -->
          <div class="product-card__body">
            <div class="product-card__badges-row">
              <span class="product-card__cat-badge">{{ product.category }}</span>
              @if (product.inStock) {
              <span class="product-card__stock product-card__stock--in">{{ 'landing.products.in_stock' | translate }}</span>
              } @else {
              <span class="product-card__stock product-card__stock--out">{{ 'landing.products.out_of_stock' | translate }}</span>
              }
            </div>

            <h3 class="product-card__name">{{ product.name }}</h3>

            <!-- Stars -->
            <div class="product-card__rating">
              @for (star of [1,2,3,4,5]; track star) {
              <mat-icon class="product-card__star"
                [class.product-card__star--filled]="star <= product.rating">star</mat-icon>
              }
              <span class="product-card__reviews">({{ product.reviews }})</span>
            </div>

            <!-- Price -->
            <div class="product-card__price">
              @if (product.discount) {
              <span class="product-card__price-current">TZS {{ getDiscountedPrice(product) | number:'1.0-0' }}</span>
              <span class="product-card__price-original">TZS {{ product.price | number:'1.0-0' }}</span>
              } @else {
              <span class="product-card__price-current">TZS {{ product.price | number:'1.0-0' }}</span>
              }
            </div>

            <!-- Actions -->
            <div class="product-card__actions">
              <button (click)="viewProductDetails(product)" class="product-card__btn product-card__btn--outline">{{ 'landing.products.view_details' | translate }}</button>
              <button (click)="addToCart(product)" [disabled]="!product.inStock"
                class="product-card__btn product-card__btn--primary">{{ 'landing.products.add_to_cart' | translate }}</button>
            </div>
          </div>

          <!-- Bottom accent bar -->
          <div class="product-card__accent-bar"></div>
        </div>
        }
      </div>

      <!-- View All -->
      <div class="products-section__cta">
        <button class="cta-btn cta-btn--primary cta-btn--lg">
          <mat-icon>store</mat-icon>
          {{ 'landing.products.view_all' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════
       FOOTER
  ══════════════════════════════════════════════════ -->
  <footer class="footer" id="contact">
    <div class="footer__blobs">
      <div class="footer__blob footer__blob--1"></div>
      <div class="footer__blob footer__blob--2"></div>
    </div>
    <div class="footer__inner">
      <div class="footer__brand">
        <div class="footer__logo">
          <mat-icon>point_of_sale</mat-icon>
        </div>
        <span class="footer__name">Nova Point</span>
      </div>
      <p class="footer__tagline">{{ 'landing.footer.tagline' | translate }}</p>
      <div class="footer__links">
        <a routerLink="/privacy-policy" class="footer__link">{{ 'landing.footer.privacy_policy' | translate }}</a>
        <span class="footer__sep">•</span>
        <a routerLink="/terms-of-service" class="footer__link">{{ 'landing.footer.terms_of_service' | translate }}</a>
        <span class="footer__sep">•</span>
        <a href="mailto:us@support.akiliunde.com" class="footer__link">{{ 'landing.footer.support' | translate }}</a>
      </div>
      <p class="footer__copy">{{ 'landing.footer.copyright' | translate: { year: currentYear } }}</p>
    </div>
  </footer>

</div>